export function IconPlay() {
  return (
    <svg
      width="28px"
      height="30px"
      viewBox="0 0 20 24"
      aria-hidden
      focusable="false"
      style={{ position: "relative", left: 4 }}
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-1097, -98)">
          <g className="svg-icon-fill" transform="translate(1097, 98)">
            <path
              d="M12.353417,5.81764562 L19.5963888,17.9678895 C20.3505026,19.2329319 19.9363131,20.8697815 18.6712706,21.6238953 C18.2583437,21.8700482 17.7865553,22 17.3058268,22 L2.72553415,22 C1.25277482,22 0.0588674857,20.8060927 0.0588674857,19.3333333 C0.0588674857,18.8474358 0.191627092,18.3707729 0.442805751,17.9548334 L7.78012663,5.80458951 C8.54145114,4.54387342 10.1806389,4.13903656 11.441355,4.90036107 C11.8160515,5.12663377 12.1292874,5.44166329 12.353417,5.81764562 Z"
              id="play"
              transform="translate(10, 12) rotate(90) translate(-10, -12)"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export function IconPause() {
  return (
    <svg
      width="21px"
      height="23px"
      viewBox="0 0 21 23"
      aria-hidden
      focusable="false"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g className="svg-icon-fill" transform="translate(-1152, -98)">
          <g id="icon-pause" transform="translate(1152, 98)">
            <rect id="rect" x="0" y="0" width="8" height="23" rx="4"></rect>
            <rect id="rect" x="13" y="0" width="8" height="23" rx="4"></rect>
          </g>
        </g>
      </g>
    </svg>
  );
}
